import type { CheckoutOutcome } from '../hooks/useCheckoutFrameEvents';
import type { QuoteJourney } from '../hooks/useElemisCheckout';

export type PaymentNavControl = 'hidden' | 'retry' | 'reopen' | 'continue';

interface PaymentNavControlInput {
    outcome: CheckoutOutcome | null;
    journey: QuoteJourney;
    liveCheckoutHeld: boolean;
}

export function paymentNavControl({ outcome, journey, liveCheckoutHeld }: PaymentNavControlInput): PaymentNavControl {
    if (outcome === 'completed') {
        return 'hidden';
    }
    if (outcome !== null) {
        return journey === 'motorplan_collects' ? 'retry' : 'continue';
    }
    return liveCheckoutHeld ? 'reopen' : 'continue';
}
